import { useCallback, useMemo, useState } from "react";
import { resolveFeatureAction } from "../data/homeFeatures";
import { useOpenCompetitorScopeFlow } from "./useOpenCompetitorScopeFlow";
import { useStartCreateCampaign } from "./useStartCreateCampaign";

const useHomeFeatureActions = () => {
  const [isCreateWithIAOpen, setIsCreateWithIAOpen] = useState(false);
  const [isShareModalOpen, setIsShareModalOpen] = useState(false);

  const { startCreateCampaign, canCreateCampaign, brandInformation } =
    useStartCreateCampaign({ fetchBrandOnMount: true });

  const competitorScope = useOpenCompetitorScopeFlow({ brandInformation });

  const onOpenCreateWithIA = useCallback(() => {
    setIsCreateWithIAOpen(true);
  }, []);

  const onCloseCreateWithIA = useCallback(() => {
    setIsCreateWithIAOpen(false);
  }, []);

  const onOpenShareModal = useCallback(() => {
    setIsShareModalOpen(true);
  }, []);

  const onCloseShareModal = useCallback(() => {
    setIsShareModalOpen(false);
  }, []);

  const runners = useMemo(
    () => ({
      createCampaign: canCreateCampaign ? startCreateCampaign : null,
      createWithIA: onOpenCreateWithIA,
      shareModal: onOpenShareModal,
      competitorScope: competitorScope.openCompetitorScope,
    }),
    [
      canCreateCampaign,
      competitorScope.openCompetitorScope,
      onOpenCreateWithIA,
      onOpenShareModal,
      startCreateCampaign,
    ]
  );

  const resolveAction = useCallback(
    (feature) => resolveFeatureAction(feature, runners),
    [runners]
  );

  return {
    resolveAction,
    isCreateWithIAOpen,
    onCloseCreateWithIA,
    isShareModalOpen,
    onCloseShareModal,
    competitorScopeModalsProps: competitorScope.modalsProps,
  };
};

export default useHomeFeatureActions;
